module.exports = __webpack_public_path__ + "img/logo-header.f69c5400.png";